<template>
  <f7-page name="upcoming" class="upcoming">
    <f7-navbar title="My Events" back-link="Back">
      <f7-nav-right>
        <f7-link  href="/" class="menu-icon"><i class="az-icon-home-house-interface-ui-website"></i></f7-link>
      </f7-nav-right>
    </f7-navbar>

      <f7-row>
        <div class="col-40 col-sm-0">
          <div class="left-az-logo">
            <img src="../assets/images/left-logo.png" alt="" />
          </div>
        </div>
        <div class="col-60 col-sm-100">
          <f7-block-title>My Events</f7-block-title>
                <!-- <f7-list no-hairlines-md cl class="login-input" style="margin: 10px;"> -->
                  <form class="searchbar" style="margin: 5px 35px">
                    <div class="searchbar-inner">
                      <div class="searchbar-input-wrap">
                        <input type="search" v-model="searchtext" v-on:keyup="searchEvents">
                        <i class="searchbar-icon"></i>
                        <span class="input-clear-button"></span>
                      </div>
                      <span class="searchbar-disable-button">Cancel</span>
                    </div>
                  </form>
                  <!-- <f7-searchbar
                    disable-button-text="Cancel"
                    placeholder="Search in items"
                    :clear-button="true"
                    v-model="searchtext"
                    v-on:keyup.native="searchEvents"
                  ></f7-searchbar> -->
                  <!-- <f7-list-input
                    style="margin: 0; padding: 0; border: 1px solid #870047;  border-radius: 15px;"
                    outline
                    type="text"
                    placeholder="Identity (username or phone)"
                    :value="searchtext"
                    @input="searchtext = $event.target.value"
                    v-on:keyup.native="searchEvents"
                    label="Search events by title"
                  ></f7-list-input> -->
                <!-- </f7-list> -->
              <div class="upcoming-box" v-if="events.length">
                <ul id="first-list">
                  <!-- list-  -->
                  <li v-for="event in events" :key="event.id">
                    <span></span>
                    <a href="#" @click.prevent="showDetails(event)" class="item-link">
                      <div class="time">
                          <span>{{ formateDate(event) }}</span>
                          <!-- <span>12:00 AM</span> -->
                      </div>
                      <div class="box-list-content">
                        <div class="right-box-block purpleBg">
                          <div class="right-box-block-cont">
                              <i class="az-icon-calendar-date-schedule"></i>
                          </div>
                        </div>
                        <div class="title">{{ event.title }}</div>
                        <!-- <div class="info">.</div> -->
                        <!-- <div class="name"><i class="fa fa-street-view" aria-hidden="true"></i>Dr.Ahmed Ali</div> -->
                        <div class="location"><i class="fa fa-map-o" aria-hidden="true"></i>{{ event.venue }}, {{ event.location }}</div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
        </div>
      </f7-row>

  </f7-page>
</template>
<script>
export default {
  data() {
    return {
      searchtext: '',
      events: [],
      oldEvents: [],
      attrs: [],
      currentEvents: [],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    }
  },
  methods: {
    searchEvents() {
      if(!this.events.length && this.searchtext.length)
        this.events = this.oldEvents;

      if(this.events.length && this.searchtext.length) {
        var vm = this
        this.events = this.events.filter(function(item) {
          return item.title.includes(vm.searchtext.replace(/\s+/g, ' ').trim());
        })
      }

      if(this.searchtext == ''){
        this.events = this.oldEvents
      }
    },
    formatAMPM(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    },
    formateDate: function(event) {
      var d = new Date(event.event_time.replace(/-/g, "/"))
      return d.getDate() + ' ' + this.months[d.getMonth()] + '  '+ d.getFullYear() + ' ' +this.formatAMPM(new Date(event.event_time.replace(/-/g, "/")))
    },
    showDetails(event) {
      sessionStorage.setItem('currentEvent', JSON.stringify(event))
      this.$f7.view.current.router.navigate( '/event-details/'+ event.id )
    }
  },
  mounted: function() {
    this.$f7.preloader.show()
    this.$http.get( this.$root.apiBaseURL + 'my-events' )
      .then( (res) => {
        this.$f7.preloader.hide()
        this.events = res.data.events
        this.oldEvents = res.data.events
      })
      .catch( (err) => {
        this.$f7.preloader.hide()
        console.log(err)
      })
  }
}
</script>
<style scoped>
  .menu-icon i::before {
    color: #870047;
    font-size: 35px;
  }
</style>
